import { c as _c } from "react/compiler-runtime";
import type { LpCardListNote } from '@cc-shopping/contracts/credit-cards-page/landing-page/CreditCardsLPCardList';
import { Box, Typography } from '@mui/material';
import { noteAnchorId, noteMarker } from '../notes';
type Props = {
  anchorPrefix: string;
  notes: LpCardListNote[];
};
export function FinePrint(t0) {
  const $ = _c(8);
  const {
    anchorPrefix,
    notes
  } = t0;
  if (!notes.length) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== anchorPrefix || $[2] !== notes) {
    let t3;
    if ($[4] !== anchorPrefix) {
      t3 = (note, index) => {
        const position = index + 1;
        return <Typography key={note.label} id={noteAnchorId(anchorPrefix, position)} sx={{
          color: "blues.main",
          fontSize: 12,
          fontWeight: "lighter"
        }}><Typography component="span" sx={{
            fontSize: "inherit",
            textDecoration: "underline"
          }}>{noteMarker(position)}</Typography>{" "}<strong>{note.label}</strong> {note.body}</Typography>;
      };
      $[4] = anchorPrefix;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = notes.map(t3);
    $[1] = anchorPrefix;
    $[2] = notes;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Box sx={t1}>{t2}</Box>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}